import { render, staticRenderFns } from "./sch_jiuye.vue?vue&type=template&id=6e84ea88&scoped=true"
import script from "./sch_jiuye.vue?vue&type=script&lang=js"
export * from "./sch_jiuye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e84ea88",
  null
  
)

export default component.exports